import { render, staticRenderFns } from "./myOrder.vue?vue&type=template&id=118405e3&scoped=true"
import script from "./myOrder.vue?vue&type=script&lang=js"
export * from "./myOrder.vue?vue&type=script&lang=js"
import style0 from "./myOrder.vue?vue&type=style&index=0&id=118405e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118405e3",
  null
  
)

export default component.exports